export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";